<template>
  <div>
    <v-data-table
      v-if="productsSelected.length"
      :headers="resultHeaders"
      :items="productsSelected"
      hide-default-footer
      class="elevation-0 table-sales mb-3"
    >
      <template v-slot:item.actions="{ item }">
        <div class="action-icons">
          <v-icon
            color="rgba(0,0,0,.54)"
            class="size-30"
            @click="$emit('changePosition', item.listID)"
            >mdi-pencil</v-icon
          >
          <v-icon
            color="#ed1b24"
            class="size-30"
            @click="$emit('deleteproduct', item.listID)"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: ['productsSelected', 'headers'],
  data() {
    return {
      defaultHeaders: [
        { text: 'Название', value: 'name', sortable: false, align: 'left' },
        {
          text: 'Кол-во',
          value: 'quantity',
          sortable: false,
          align: 'center',
          width: 80,
        },
        { text: 'Цена', value: 'cost', sortable: false, align: 'center' },
        { text: '', value: 'actions', sortable: false, align: '' },
      ],
    };
  },
  computed: {
    resultHeaders() {
      if (this.headers) {
        return this.headers;
      }
      return this.defaultHeaders;
    },
  },
  methods: {
    /**
     * Получение уникальных кодов товара
     * @param product - объект товара
     * @returns {{code: null | string, id: null | number}}
     */
    // GetBarcode(product) {
    //   if (product.barcode_id) {
    //     return { id: product.barcode_id, code: product.barcode_code };
    //   }
    //   if (product.barcode && product.barcode.id) {
    //     return { id: product.barcode.id, code: product.barcode.code };
    //   }
    //   return { id: null, code: null };
    // },
  },
};
</script>
<style lang="scss" scoped>
.action-icons {
  display: flex;
}
</style>
